import { Component, OnInit, Input, QueryList, ViewChildren, OnDestroy, } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { FormTextInputComponent } from '../form-text-input/form-text-input.component';
import { FormTextAreaComponent } from '../form-text-area/form-text-area.component';
import { FormDropdownComponent } from '../form-dropdown/form-dropdown.component';
// import { FormCheckboxComponent } from '../form-checkbox/form-checkbox.component';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { ApiService } from '../../services/ApiService';
import { RestService } from '../../services/RestService';

import { Subscription } from 'rxjs';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { JssContextService } from '../../jss-context.service';
// import { deflate } from 'pako';


@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  jssStylingService: JssStylingService;
  dynamicClass: string;
  options: any[] = [];
  selectedInterests: any[] = [];
  loading:boolean;
  submissionResponse: string ="";
  private reCaptchaSubscription: Subscription;

  @ViewChildren(FormTextInputComponent)
  formTextInputComponents: QueryList<FormTextInputComponent>;
  @ViewChildren(FormTextAreaComponent)
  formTextAreaComponents: QueryList<FormTextAreaComponent>;
  @ViewChildren(FormDropdownComponent)
  formDropdownComponents: QueryList<FormDropdownComponent>;
  warningFlag: boolean = false;
  // public maskNumber: {} = { mask : /^\d*$/ };
  contactForm: any;
  contextSubscription:any;
  language:string;
  currentRoute:string;

  constructor(jssStylingService: JssStylingService, protected apiService: ApiService,
     private recaptchaV3Service: ReCaptchaV3Service,
      private jssContext: JssContextService, private RestService: RestService) {
    this.jssStylingService = jssStylingService;
    
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('ContactForm component initialized with component data', this.rendering);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language;
      this.currentRoute = newState.serverRoute;
    });
    this.initializeForm();

    (this.rendering.fields?.DropdownItems as any)?.forEach((item: any) => {
      let option = {
        text: item.fields?.Text?.value,
        value: item.fields?.Value?.value,
      };
      this.options.push(option);
      console.log(this.options);
    })
    
  }

  onChange() {
    const companyName = this.contactForm.get('companyName');
    const position = this.contactForm.get('position');

    if(this.contactForm.get('dropdown')?.value == '1') {
      companyName.addValidators([Validators.required, this.alphabeticValidator()]);
      position.addValidators([Validators.required, this.alphabeticValidator()]);
    } else {
      companyName.clearValidators()
      position.clearValidators();
    }

    companyName.updateValueAndValidity();
    position.updateValueAndValidity();
  }

  initializeForm(): void {
    const productControls: { [key: string]: FormControl } = {};
  
    // Get items from rendering safely
    const items = this.rendering?.fields?.MultipleCheckboxItems || [];
  
    // Dynamically create controls using actual product values as keys
    (items as any[]).forEach((item) => {
      const key = item.fields?.Value?.value;
      if (key) {
        productControls[key] = new FormControl(false);
      }
    });
  
    const products = new FormGroup(productControls);
  
    // Main form
    this.contactForm = new FormGroup({
      dropdown: new FormControl('', [Validators.required]),
      name: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
        this.alphabeticValidator()
      ]),
      surname: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(30),
        this.alphabeticValidator()
      ]),
      companyName: new FormControl(''),
      position: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.email]),
      telephone: new FormControl(''),
      products, // dynamic product checkboxes
      message: new FormControl('', [this.textAreaValidator()]),
      termsCheckbox: new FormControl(false, [
        Validators.required,
        Validators.requiredTrue
      ]),
    });
  
    this.contactForm.get('companyName')?.disable();
    this.contactForm.get('position')?.disable();
  }
  
  
  isFieldInvalid(field: string): boolean {
    return this.contactForm.get(field)?.touched && this.contactForm.get(field)?.invalid;
  }

  alphabeticValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        // If the field is empty, validation passes (no error)
        return null;
      }
      const valid = /^[\p{L}\s]+$/u.test(control.value); // Allow only alphabets and spaces
      return valid ? null : { alphabeticOnly: true };
    };
  }

  textAreaValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        // If the field is empty, validation passes (no error)
        return null;
      }
      const valid = /^[\p{L}\p{N}\s.,!?'"()\-:;@#&]+$/u.test(control.value);  // Allow only alphabets and spaces
      return valid ? null : { alphabeticOnly: true };
    };
  }

  clearForm() {
    // Reset everything else in the form
    this.contactForm.reset();
  
    // Explicitly reset the 'products' group
    const productControls = (this.contactForm.get('products') as FormGroup).controls;
    Object.keys(productControls).forEach(key => {
      productControls[key].setValue(false, { emitEvent: false }); // force uncheck
      productControls[key].markAsPristine();
      productControls[key].markAsUntouched();
    });
  
    // Clear internal state
    this.selectedInterests = [];
  
    // Disable companyName/position again
    this.contactForm.get('companyName')?.disable();
    this.contactForm.get('position')?.disable();
  
    // Re-validate form
    this.contactForm.updateValueAndValidity();
  }
  
  

  changeSelectedCategories(): void {
    const productControls = (this.contactForm.get('products') as FormGroup).controls;
    this.selectedInterests = Object.entries(productControls)
      .filter(([, control]) => control.value === true)
      .map(([key]) => key);
      //console.log(this.selectedInterests,"selectedInterests")
  }
  // changeSelectedCategories(index:number){
  //   const value = ((this.rendering?.fields?.MultipleCheckboxItems as any)[index] as any).fields?.Value?.value;
  //   if(this.contactForm.get('products.product'+index)?.value){
  //     this.selectedInterests.push(value);
  //   }else{
  //     const indexToRemove = this.selectedInterests.indexOf(value);
  //     if (indexToRemove !== -1) {
  //       this.selectedInterests.splice(indexToRemove, 1);
  //     }
  //   }
  // }

  onSubmit() {
    // options[options.FindIndex(option => option.value == value)].text
    this.contactForm.updateValueAndValidity();
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();  // This will mark all controls as touched
    }
    if (this.contactForm.valid) {
      this.loading=true;
      this.reCaptchaSubscription = this.recaptchaV3Service.execute('formSubmission').subscribe(
        (token) => {
          this.RestService.validateToken(token).subscribe({
            next: (respRecaptcha: any) => {
              // If recaptcha is valid
              if(respRecaptcha.success){

                var request = {
                  nameTo: this.contactForm.get('name').value,
                  email: this.contactForm.get('email').value,
                  emailTo: (this.rendering?.fields?.EmailTo as any).value,//this.contactForm.get('email').value,
                  surname: this.contactForm.get('surname').value,
                  telephone: this.contactForm.get('telephone').value,
                  interestedProducts: this.selectedInterests,
                  individualOrCompany: this.contactForm.get('dropdown').value == '1' ? "company" : "individual",
                  companyName: this.contactForm.get('companyName')?.value,
                  positionInCompany: this.contactForm.get('position')?.value,
                  message: this.contactForm.get('message')?.value,
                  subject:"contact form"
                };
  
                if (this.language && this.language.toLocaleLowerCase() == 'el-gr'){
                  this.language = 'el';
                }
                // const action = `/sitecore/api/layout/render/jss?item=%2F${this.notfoundPagename}%2F&sc_lang=${this.language}&sc_apikey=${this.sitecoreApiKey}&sc_site=eurobankequities`;
                
                const json = JSON.stringify(request);
                const base64 = btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=+$/, '');
                
                const action = `/sitecore/api/layout/render/jss?item=${this.currentRoute.replace(/\//g, "%2F")}%2F&sc_lang=${this.language}&sc_apikey={40D54338-B819-42F3-8C9D-114AE2C043BF}&sc_site=eurobankequities&sc_params=${base64}`;
                this.apiService.fetchLayoutService<any[]>(action,"")
                  .then(resp => {
                    if (resp.status === 200) {
                      var response = (resp.data as any).sitecore.route.placeholders["jss-main"].filter((x:any )=> x?.componentName == "ContactForm")[0];
                      if(response?.fields?.result?.apiSuccess){
                        this.submissionResponse = "success";
                      }else{
                        this.submissionResponse = "fail";
                      }
                      this.loading = false;
                      this.clearForm();
                      setTimeout(() => {
                        document.getElementById("contactSumbitMessage").scrollIntoView({block:'center'});
                      }, 5);
                    }
                    else{
                      this.loading = false;
                    }
                  });
              }else{
                this.submissionResponse = "fail";
                this.loading = false;
              }
            },
            error: (err) => {
              console.error('API error:', err);
              this.submissionResponse = "fail";
              this.loading = false;
            }
          });
   


          
          // const jsonString = JSON.stringify(request);
          // const encoder = new TextEncoder();
          // const byteData = encoder.encode(jsonString);
          // console.log(base64OLD);
          // // Step 1: Gzip compress
          // const compressed = deflate(byteData);
      
          // // Step 2: Base64 encode
          // const base64 = this.arrayBufferToBase64(compressed);
      
          // // Step 3: Make it URL-safe
          // const urlSafe = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
          // debugger;
          
        });
    }
  }

  // private arrayBufferToBase64(buffer: Uint8Array): string {
  //   let binary = '';
  //   const len = buffer.byteLength;
  //   for (let i = 0; i < len; i++) {
  //     binary += String.fromCharCode(buffer[i]);
  //   }
  //   return btoa(binary);
  // }

  ngOnDestroy(): void {
    if (this.reCaptchaSubscription) {
        this.reCaptchaSubscription.unsubscribe();
    }
  }
}
